import { useMemo, useState, MouseEvent } from 'react';
import getOffset from '@/Framework/dom/getOffset';
import { StrictModifiers } from '@popperjs/core';

export const usePopoverModifier = () => {
  const [tooltipOffset, setTooltipOffset] = useState({ left: 0, top: 0 });

  const popperModifiers: StrictModifiers[] = useMemo(() => [
    {
      name: 'offset',
      options: {
        offset: ({ popper }) => {
          const halfPopperWidth = popper.width / 2;
          return [tooltipOffset.left - halfPopperWidth, tooltipOffset.top];
        },
      },
    },
  ], [tooltipOffset]);

  const getTooltipOffset = (event: MouseEvent) => {
    const dealHeaderTarget = event.currentTarget as HTMLElement;
    const { viewportTop, viewportLeft, height, width } = getOffset(dealHeaderTarget);

    const leftOffset = event.clientX - viewportLeft - width / 2;
    const topOffset = event.clientY - viewportTop - height;

    return { left: leftOffset, top: topOffset };
  };

  return {
    popperModifiers,
    setTooltipOffset,
    getTooltipOffset,
  };
};
